import React, {useEffect, useRef} from "react"
import style from  "./Modal.module.scss";
import Icon from "../Icon/Icon";
import Button from "../Button/Button";

const Modal = props => {

    // 열기, 닫기, 모달 헤더 텍스트를 부모로부터 받아옴
    const {
      open,
      handle_Close,
      width,
      height,
      title="",
      isHeader = true,
      isBottom= false ,
      bottomBtnText
    } = props

    // 모달 오픈시 부모창 스크롤 지우기
    useEffect(() => {
        document.body.style.overflow = (open) ? 'hidden':'unset';

        return () => { //팝업 닫기
            document.body.style.overflow = 'unset';
        };
    }, [open]);

    const selectStyle = {
        maxWidth: width,
        Height: '100%'
    };

    const mainStyle = {
        maxHeight: height,
        Height: '100%',
        overflowY: 'auto'
    }

    const saveCallbackRef = useRef();
    const handle_save = () => {
        if (saveCallbackRef.current) {
            saveCallbackRef.current(); // 자식이 넘겨준 함수 실행
        }
    }

    return (
        // 모달이 열릴때 openModal 클래스가 생성된다.
        <div className={`${style.modal} ${ open ? style.openModal:null}`}>
            {open ? (
                <section style={selectStyle}>
                    {isHeader ? (
                    <header>
                        {title}
                        <button onClick={handle_Close}>
                            <Icon id="close_01" width="32" height="33"/>
                        </button>
                    </header>
                    ) : null}
                    <main style={mainStyle}>
                        {/*{props.children}*/}
                        {React.isValidElement(props.children) &&
                            React.cloneElement(props.children, {
                                comHandleClick_Save: (fn) => { saveCallbackRef.current = fn; }
                            })}
                    </main>
                    {isBottom &&
                    <footer>
                      {/* 버튼 그룹  [cancel, confirm ] */}
                      {(bottomBtnText?.cancel || !bottomBtnText) &&
                      <Button variant="Tertiary" size="md" addStyle={{width: "392px", height: "52px"}}
                              onClick={() => handle_Close()}>
                        {bottomBtnText?.cancel || "취소"}
                      </Button>
                      }
                      {(bottomBtnText?.confirm || !bottomBtnText) &&
                      <Button variant="Primary" size="md" addStyle={{width: "392px", height: "52px"}}
                              onClick={() => handle_save()}>
                        {bottomBtnText?.confirm || "확인"}
                      </Button>
                      }
                    </footer>
                    }
                </section>
            ) : null}
        </div>
    );
};


export default Modal;